import type { RouteObject } from 'react-router';

import * as viewJobHorizonRoute from 'modules/listing/pages/jobs/view/ViewJob.horizon-route';
import { horizonRouteToObject } from 'routing/utils/horizonRouteToObject';

import { eventRouteObjects } from './event/event.route-objects';
import { internshipRouteObjects } from './internship/internship.route-objects';
import { jobSegmentedRoutes } from './job/job.routes';
import { orgRouteObjects } from './org/org.route-objects';
import { volopRouteObjects } from './volop/volop.route-objects';

export const listingRouteObjects = [
  ...eventRouteObjects,
  ...internshipRouteObjects,

  ...jobSegmentedRoutes.map<RouteObject>((segmentedRoute) => ({
    path: segmentedRoute.fullPath,
    ...horizonRouteToObject(viewJobHorizonRoute),
  })),

  ...volopRouteObjects,
  ...orgRouteObjects,
] satisfies RouteObject[];
